export class Table {

    public qrCode: string = ''

    constructor(public name: string) {

    }

}